<template lang="">
    <!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        Start Sticky Bar Section
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
    <section class="stickyBar-section">
        <div class="stickyBar-list-wrapper">
            <button class="stickyBar-toggle-btn"><i class="las la-info-circle"></i></button>
            <div class="top-wrapper">
                <h6 class="title">Free Support:</h6>
                <ul class="stickyBar-list free">
                    <li><i class="lab la-free-code-camp"></i>Server Issues</li>
                    <li><i class="lab la-free-code-camp"></i>DB Migration Issues</li>
                    <li><i class="lab la-free-code-camp"></i>Configuration Issues</li>
                    <li><i class="lab la-free-code-camp"></i>Project Issues</li>
                    <li><i class="lab la-free-code-camp"></i>Reset Purchase Code (max 1 time)</li>
                </ul>
                <h6 class="title">Unsupported:</h6>
                <ul class="stickyBar-list unsupported">
                    <li><i class="las la-exclamation-triangle"></i>Environment Setup</li>
                    <li><i class="las la-exclamation-triangle"></i>Deploy on Localhost</li>
                    <li><i class="las la-exclamation-triangle"></i>After Code Modification</li>
                </ul>
                <h6 class="title">Paid Support:</h6>
                <ul class="stickyBar-list paid">
                    <li><i class="las la-crown"></i>Installation</li>
                    <li><i class="las la-crown"></i>APK build</li>
                    <li><i class="las la-crown"></i>Update Template</li>
                    <li><i class="las la-crown"></i>Adding New Feature</li>
                    <li><i class="las la-crown"></i>API Integration and many more...</li>
                </ul>
            </div>
            <div class="stickyBar-box">
                <h6 class="title">WE ARE NOW</h6>
                <h6 class="subtitle"><svg width="200px" height="200px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill=""><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="" d="M23.032 5.072c-0.668-0.371-2.581-0.141-4.88 0.57-4.022 2.75-7.417 6.8-7.654 13.305-0.043 0.156-0.44-0.021-0.518-0.069-1.086-2.082-1.517-4.274-0.61-7.437 0.169-0.281-0.384-0.628-0.483-0.529-0.199 0.199-1.029 1.083-1.58 2.040-2.732 4.74-0.946 10.813 3.835 13.47 4.779 2.662 10.814 0.945 13.475-3.836 3.078-5.518 0.219-16.506-1.585-17.514z"></path> </g></svg>ENVATO ELITE AUTHOR</h6>
                <a href="https://codecanyon.net/user/appdevsx/portfolio" target="_blank" class="stickyBar-box-btn">View Portfolio <i class="las la-angle-right"></i></a>
            </div>
        </div>
    </section>
    <!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        End Sticky Bar Section
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
    </template>
    
    <script>
    /* eslint-disable no-undef */
    export default {
        name: 'stickyBarSection',
        mounted(){
            $(document).ready(function() {
                var $stickyBarToggleBtn = $(".stickyBar-toggle-btn"),
                    $bodyOverlay = $(".body-overlay"),
                    $stickyBar = $(".stickyBar-list-wrapper");

                $stickyBarToggleBtn.click(function() {
                    toggleStickyBar();
                });

                $bodyOverlay.click(function() {
                    closeStickyBar();
                });

                function toggleStickyBar() {
                    $stickyBar.toggleClass("active");
                    $bodyOverlay.addClass("active");
                }

                function closeStickyBar() {
                    $bodyOverlay.removeClass("active");
                    $stickyBar.removeClass("active");
                }
            });
        }
    }
    </script>
    
    <style lang="">
        
    </style>